import { requestPointerLock } from "@utils/requestPointerLock";
import { ScreenSize, ScreenSizeListener } from "realms-react-utils";
import { BehaviorSubject } from "rxjs";

export class GameMenuService {
  private showingMenuSubject$ = new BehaviorSubject(false);
  readonly showingMenu$ = this.showingMenuSubject$.asObservable();
  private screenSizeListener = new ScreenSizeListener();

  showMenu() {
    this.showingMenuSubject$.next(true);
    if (this.screenSizeListener.getScreenSize() === ScreenSize.Desktop) {
      window.document.exitPointerLock();
    }
  }

  closeMenu() {
    this.showingMenuSubject$.next(false);
    if (this.screenSizeListener.getScreenSize() === ScreenSize.Desktop) {
      requestPointerLock();
    }
  }
}
